import script from "./BookCover.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookCover.vue?vue&type=script&setup=true&lang=ts"

import "./BookCover.vue?vue&type=style&index=0&id=88b0b9b4&lang=scss"

const __exports__ = script;

export default __exports__